import { Link, useLocation } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFoundPage() {
  const { pathname } = useLocation();
  return <section className="mx-auto max-w-3xl px-6 py-28 text-center">
    <SEO title="페이지를 찾을 수 없습니다" path={pathname} noindex />
    <h1 className="text-3xl font-bold">페이지를 찾을 수 없습니다</h1>
    <p className="mt-4 text-gray-600">주소를 확인하거나 제품 목록에서 찾아주세요.</p>
    <Link to="/store" className="mt-8 inline-block underline">제품 목록으로 이동</Link>
  </section>;
}
